var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field flex-center"},[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }